module.exports = __webpack_public_path__ + "static/media/ei-high-performers.958192fe.png";